<div class="dropdown">
  <div class="drop-btn" [cdkMenuTriggerFor]="menu">
    <img class="avatar" [ngSrc]="userImage" width="32" height="32" />
  </div>
</div>

<ng-template #menu>
  <div class="drop-content" cdkMenu>
    <div class="user-panel">
      <div class="image">
        <img class="avatar" [ngSrc]="userImage" width="32" height="32" />
      </div>
      <div class="info">
        <small class="d-block">{{ userName }}</small>
      </div>
    </div>
    @for (action of actions; track action.name) {
    <div
      class="drop-item"
      (cdkMenuItemTriggered)="onAction(action)"
      cdkMenuItem
    >
      {{ action.title }}
    </div>
    }
  </div>
</ng-template>
